/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import Table from "react-bootstrap/Table";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";

// import presidentsArray from "assets/texts/presidents.json";

function CookiesSite() {
  const impressum = `
  <h4>Was sind Cookies? </h4>
  <p>Cookies sind Datenpakete, die zwischen Computerprogrammen ausgetauscht werden. 
  Allgemein werden mit dem Begriff meist HTTP-Cookies bezeichnet, mit deren Hilfe Websites Nutzerdaten lokal und serverseitig speichern, 
  um einzelne Funktionen und Webanwendungen wie Onlineshops, soziale Netzwerke und Foren nutzerfreundlicher gestalten zu können.
  Dabei werden personenbezogene Daten gesammelt und beispielsweise Login-Daten, Surfverhalten, Einstellungen und Aktionen in Webapplikationen zu speichern.</p><br>

  <h4> Auf der Website verwendete Cookies </h4>
  <p>Auf dieser Website werden verschiedene Arten von Cookies zu unterschiedlichen Zwecken verwendet. Nachstehend werden die verwendeten Cookies aufgeführt:</p>
  [ Aktuell verwendet die Website keine nicht notwendigen Cookies ]<br><br>

  <p>Es kann sein, dass infolge der Deaktivierung von Cookies die Webseite nicht ordnungsgemäß funktioniert oder der Zugriff auf bestimmte Funktionen darauf nicht möglich ist.</p> <br>

  <h4>Änderung der Bedingungen</h4>
  <p>Der Brauchtumsverein Bachrose Bietingen e.V. behält sich ausdrücklich das Recht vor, diese Cookie-Richtlinie einseitig, 
  vollständig oder teilweise sowie ohne Vorankündigung zu ändern. Der Benutzer nimmt zur Kenntnis und erteilt seine Zustimmung, 
  dass es seiner Verantwortung obliegt, diese Cookie-Richtlinie regelmäßig zu prüfen. </p><br>

  Mehr finden sie in unserer Datenschutzerklärung.
  `;

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Cookie-Richtlinien" />
      {/* <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Cookie-Richtlinien
        </MKTypography>
      </MKBox> */}
      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          pt: 8,
          pb: 8,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <MKTypography
            variant="body2"
            color="text"
            dangerouslySetInnerHTML={{ __html: impressum }}
          />
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default CookiesSite;
